import type {
  PrimitiveValueType,
  SelectOption,
  ValueType,
} from 'components/types';
import type { ItemType as DropdownItemType } from 'react-native-dropdown-picker';

export type FetcherSearchOptions<T extends Record<string, unknown> = {}> = {
  query?: string;
  include?: PrimitiveValueType[];
} & T;

export type SyncFetcher<
  TOptionValue extends ValueType,
  TData = undefined,
  TSearch extends Record<string, unknown> = {},
> = (
  search?: FetcherSearchOptions<TSearch>,
) => SelectOption<TData, TOptionValue>[];

export type AsyncFetcher<
  TOptionValue extends ValueType,
  TData = undefined,
  TSearch extends Record<string, unknown> = {},
> = (
  search?: FetcherSearchOptions<TSearch>,
) => Promise<SelectOption<TData, TOptionValue>[]>;

export type ObjectFetcher<
  TOptionValue extends ValueType,
  TData = undefined,
> = SelectOption<TData, TOptionValue>[];

export type Fetcher<
  TOptionValue extends ValueType,
  TData = undefined,
  TSearch extends Record<string, unknown> = {},
> =
  | ObjectFetcher<TOptionValue, TData>
  | SyncFetcher<TOptionValue, TData, TSearch>
  | AsyncFetcher<TOptionValue, TData, TSearch>;

export const mapOptionsToItems = <TValue extends PrimitiveValueType>(
  options: SelectOption<unknown, TValue>[],
): DropdownItemType<TValue>[] =>
  options.map<DropdownItemType<TValue>>((option) => ({
    label: option.display,
    value: option.value,
    disabled: option.isDisabled,
  }));
